export const PageLoadingSpinner = () => (
  <div
    className="flex min-h-screen items-center justify-center bg-surface-sunken p-4"
    role="status"
    aria-live="polite"
  >
    <span className="sr-only">Loading</span>
    <div className="relative flex items-center justify-center">
      <style>{`
        @keyframes spin-and-float {
          0% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-6px) rotate(180deg); }
          100% { transform: translateY(0px) rotate(360deg); }
        }
        .logo-animate {
          animation: spin-and-float 6s linear infinite;
        }
      `}</style>
      <div
        className="absolute inset-0 h-32 w-32 animate-pulse rounded-full bg-primary/20 blur-2xl"
        style={{ animationDuration: "6s" }}
      />
      <img
        src="/brand/logo.svg"
        alt=""
        aria-hidden="true"
        className="logo-animate relative h-16 w-16 shrink-0 object-contain"
      />
    </div>
  </div>
);
